<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Manage Roles"
              bc1="App"
              bc2="Roles"
              bc3="Manage Roles"
              path="Roles"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Manage Roles</h4>
                </div>
                <div class="card-body" v-show="loading">
                  <div class="col-12 d-flex mt-2  justify-content-center" >
                    <div class="spinner-border text-primary"></div>
                  </div>
                </div>
                <div v-show="!loading" class="card-body">
                  <Form class="form form-horizontal">
                    <div class="row">
                      <h6 class="section-label mx-1 mb-2">Roles</h6>
                      <div class="col-12 mb-2" >
                        <!--                        <h5 class="mb-1">{{ feature.name }}</h5>-->
                        <div class="custom-control justify-content-between custom-switch mb-1 d-inline-flex mt-1 custom-feature-width" v-for="(feature,index) in featureList" :key="index">
                          <div>
                            <input :id="index" type="checkbox" v-if="typeof(feature.checked) != 'undefined'"
                                   class="custom-control-input" v-model="feature.checked" />
                            <label :class="typeof(feature.checked) != 'undefined' ? 'custom-control-label':''" :for="index">
                              {{ feature.name}}
                            </label>
                          </div>
                          <button type="button" class="btn btn-outline-success btn-sm" @click="$router.push({name: 'roles-permissions',params: {roleId:feature.id}})">Permissions</button>
                        </div>
                      </div>
                      <div class="col-12 d-flex">
                        <button
                            type="button"
                            class="btn btn-primary mr-1 d-flex "
                            @click="sendCall"
                            :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Save Changes
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
export default {
  mounted() {
    this.getAllRoles()


  },
  data() {
    return {
      loader: false,
      featureList: [],
      tmpLIst:[],
      alreadyCheckedRoles: {},
      loading: false,
      size: "10px",

    }
  },
  methods: {
    sendCall() {

      this.$validator.validateAll().then(valid => {
        if (valid) {

          this.loading = true;
          let groupIds = []
          //extracting ids to send with the request
          this.featureList.forEach(eachFeature => {
            if (eachFeature.checked) {
              groupIds.push(eachFeature.id)
            }
          })


          let data = {
            roleIds : JSON.stringify(groupIds),
            id: parseInt(this.$route.params.userId)
          }
          this.makeRequest("post", "v1/assign-role-to-user", data).then(
              callResponse => {
                if (!callResponse.error) {
                  let code = callResponse.response.data.code;
                  if (code == 200) {

                    this.$router.back()
                  }
                }
                this.loading = false;
              }
          );
        }
      });


    },
    getAllRoles() {
      this.loading = true
      this.makeRequest('post', 'v1/get-role', {flag: 'all'}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.tmpLIst = callResponse.response.data.data
            this.getAlreadySelectedRoles()
          }
        }
        this.loading = false

      });
    },
    getAlreadySelectedRoles() {
      this.loading = true
      this.makeRequest("post", "v1/get-user-role", {
        id: parseInt(this.$route.params.userId)
      },{},false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let data = callResponse.response.data.data;
            if(data){
              if(data.roles){
                data.roles.forEach(v => {
                  this.alreadyCheckedRoles[v.id] = true
                })
              }
            }

            this.tmpLIst.forEach(eachFeature => {
              if (typeof (this.alreadyCheckedRoles[eachFeature.id]) != 'undefined') {
                eachFeature.checked = true
              } else {
                eachFeature.checked = false
              }

            })
            this.featureList = this.tmpLIst


          }
        }
        this.loading = false
      });
    },
  },
}
</script>

